import React from "react";

const Food = () => {
  const foodItems = [
    {
      title: "Indian Thali",
      img: "/images/food/1.jpg",
    },
    {
      title: "Chicken Biryani",
      img: "/images/food/2.jpg",
    },
    {
      title: "South Indian Meal",
      img: "/images/food/3.jpg",
    },
  ];

  return (
    <>
      <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
       <h1>Foods</h1>
    </div>
  </div>
</section>




      {/* FOOD SECTION */}
      <section className="food-section">
        <div className="container">
          <div className="row">
            {foodItems.map((item, index) => (
              <div className="col-lg-4 col-md-6 mb-4" key={index}>
                <div className="food-card">
                  <div className="food-img">
                    <img src={item.img} alt={item.title} />
                  </div>
                  <div className="food-content">
                    <h4>{item.title}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Food;
